import angular from 'angular';
import uiRouter from 'angular-ui-router';
import myLoansModalComponent from './myLoansModal.component';

let myLoansModalModule = angular.module('myLoansModal', [
  uiRouter
])

.component('myLoansModal', myLoansModalComponent)

.name;

export default myLoansModalModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/myLoansModal/myLoansModal.js